import { render, staticRenderFns } from "./MedicalRecords.vue?vue&type=template&id=74c8c062&scoped=true&"
import script from "./MedicalRecords.vue?vue&type=script&lang=js&"
export * from "./MedicalRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c8c062",
  null
  
)

export default component.exports